import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/**
 * @file Upload.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import { useCreateUpload, UploadContext } from '@tencent/glue-react-upload';
import { UploadStatus } from '@tencent/glue-model-upload';
import { FileList } from '../FileList/FileList';
import { ReplaceTrigger } from '../ReplaceTrigger/ReplaceTrigger';
import { RemoveTrigger } from '../RemoveTrigger/RemoveTrigger';
import { FileTrigger } from '../FileTrigger';
import { ViewTrigger } from '../Trigger/Trigger';
import { ViewCard, TriggerType } from '../Card/Card';
export var Upload = function Upload(props) {
  var children = props.children,
      extra = _objectWithoutProperties(props, _excluded);

  var upload = useCreateUpload(extra);
  return React.createElement(UploadContext.Provider, {
    value: upload
  }, props.children);
};
Upload.Trigger = ViewTrigger;
Upload.FileList = FileList;
Upload.Card = ViewCard;
Upload.ReplaceTrigger = ReplaceTrigger;
Upload.RemoveTrigger = RemoveTrigger;
Upload.FileTrigger = FileTrigger;
export { TriggerType, UploadStatus };